import { UnreachableCaseError } from '@oberoninternal/travelbase-ds/entities/UnreachableCaseError';
import { IntlShape } from 'react-intl';
import { TargetAudienceEnum } from '../generated/graphql';

const getTargetAudienceMessage = (targetAudience: TargetAudienceEnum, intl: IntlShape) => {
    switch (targetAudience) {
        case TargetAudienceEnum.AllAges:
            return intl.formatMessage({ defaultMessage: 'alle leeftijden' });
        case TargetAudienceEnum.Adults:
            return intl.formatMessage({ defaultMessage: 'volwassenen' });
        case TargetAudienceEnum.Children:
            return intl.formatMessage({ defaultMessage: 'kinderen' });
        case TargetAudienceEnum.WheelchairAccessible:
            return intl.formatMessage({ defaultMessage: 'rolstoelvriendelijk' });
        case TargetAudienceEnum.Pets:
            return intl.formatMessage({ defaultMessage: 'huisdieren' });
        default:
            throw new UnreachableCaseError(targetAudience);
    }
};

export default getTargetAudienceMessage;
